import { render, staticRenderFns } from "./Draft.vue?vue&type=template&id=45902505&scoped=true&"
import script from "./Draft.vue?vue&type=script&lang=js&"
export * from "./Draft.vue?vue&type=script&lang=js&"
import style0 from "./Draft.vue?vue&type=style&index=0&id=45902505&scoped=true&lang=css&"
import style1 from "./Draft.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45902505",
  null
  
)

export default component.exports